/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TodoListViewerFragment = { todoList: { showSeminar: boolean, showAutoKartePlannerCommentSetting: boolean, showWriteProfile: boolean } };

export const TodoListViewerFragmentDoc = gql`
    fragment TodoListViewer on Viewer {
  todoList {
    showSeminar
    showAutoKartePlannerCommentSetting
    showWriteProfile
  }
}
    `;